export default {"src":"//_next/static/media/heart.43b1febe.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};